import React from 'react';
import locationImage from '~/assets/images/advise_location.svg';
import SearchField from '~/components/forms/SearchField';
import { openInNewTab } from '~/helpers/URIhelper';
import { cn, formatNumberWithDots } from '~/helpers/utils';
import { useCalculateMaximumMortgageCalculation } from '~/pages/Tools/CalculateMaximumMortgage/Calculate/context/CalculationContext';
import {
  SearchSchema,
  type SearchFormValues,
} from '~/pages/Tools/CalculateMaximumMortgage/Calculate/schema';

type CalculationSearchProps = {
  totalOffices: number;
  totalReviews: number;
};

const CalculationSearch: React.FC<CalculationSearchProps> = ({
  totalOffices,
  totalReviews,
}) => {
  const { selected } = useCalculateMaximumMortgageCalculation();
  const handleSearch = async (value: string) => {
    const searchData: SearchFormValues = {
      search: value,
      searchScope: 'hypotheek',
    };

    const result = SearchSchema.safeParse(searchData);
    if (!result.success) {
      return;
    }

    const url = selected?.campaignCode
      ? `/hypotheek/zoekresultaat?c=${selected?.campaignCode}&geolocation=${value}`
      : `/hypotheek/zoekresultaat?geolocation=${value}`;

    openInNewTab(url);
  };

  return (
    <div
      className={cn(
        'relative rounded-b-lg bg-blue-700',
        '-mx-6 -mb-6 mt-6 p-6',
        'md:-mx-8 md:-mb-8 md:px-8',
        'md:-mb-10 md:px-10 xl:-mx-10'
      )}
    >
      <SearchField
        name="search"
        label="Zoek een hypotheekadviseur"
        labelClass="!text-white !text-lg"
        inputContainerClass="gap-0"
        inputClass="!rounded-r-none"
        buttonVariant="blue"
        buttonClass="!px-0 !w-14 !rounded-l-none"
        placeholder="Postcode/woonplaats"
        scope="hypotheek"
        onSubmitSearch={handleSearch}
      />
      <div className="flex items-center gap-2">
        <img className="w-8" src={locationImage} alt="" />
        <div className="text-balance text-sm text-white">
          <strong>{formatNumberWithDots(totalOffices)} advieskantoren</strong>{' '}
          staan vermeld op Advieskeuze en hebben samen{' '}
          <strong>
            {formatNumberWithDots(totalReviews)} onafhankelijke klantreviews
          </strong>{' '}
          ontvangen.
        </div>
      </div>
    </div>
  );
};

export default CalculationSearch;
